import * as ng from 'angular';
import { AuthContextService, NavigationService } from '../../../../../../services';
import { OrganismOverviewController, OverviewDataObject } from '../../../../../organisms';

export class MoleculeOverviewRowPanelSslJobController implements ng.IController {
    public static $inject: string[] = ['authContext', 'navigation'];

    public overviewData: OverviewDataObject;
    public OrganismOverview: OrganismOverviewController;
    public overviewLoad: (selection: any) => any;
    public internalPaginationLimit: number;

    constructor(
        private authContext: AuthContextService,
        private navigation: NavigationService
    ) {}

    public get showAccounts() {
        return this.OrganismOverview.globals.showAccounts;
    }

    public get showTriggeredBy() {
        return this.authContext.isRootOrCompanyAccount;
    }
}

export class MoleculeOverviewRowPanelSslJobComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        internalPaginationLimit: '<',
        overviewData: '<',
        overviewLoad: '<'
    };
    public controller =  MoleculeOverviewRowPanelSslJobController;
    public controllerAs = 'OverviewSslJobCtrl';
    public template = require('./ssl-certificate-job-row.html');
}
